export enum CandidateExperienceQueryKeys {
  REGISTRATION_STATUS = 'REGISTRATION_STATUS',
  WEB_OFFER = 'WEB_OFFER',
  CANDIDATE = 'CANDIDATE',
  EMPLOYEE_INFO = 'EMPLOYEE_INFO',
  EMPLOYEE_OFFERS = 'EMPLOYEE_OFFERS',
}
